<template>
    <div>
      <div class="modal hide fade" id="modalCustomerGrid" tabindex="-1" role="dialog" aria-labelledby="modalCustomerGrid" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                Customer Grid
              </h4>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="table-responsive">
                <div class="form-inline ml-auto">
                    <div class="form-group mx-sm-3 mb-2">
                        <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery">
                    </div>
                    <nav aria-label="Page navigation example" class="pull-right">
                        <ul class="pagination">
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="#" @click="prevPage">
                                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                                </a>
                            </li>
                            <li class="page-item">
                                <a class="btn btn-default btn-sm" href="#" @click="nextPage">
                                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                                </a>
                            </li>
                        </ul>
                    </nav>
                </div>
                <div class="row" v-if="customerList.length === 0">
                    <div class="col-6">
                        <div class="card" style="border: 1px solid #ccc; cursor: pointer;">
                            <div class="card-body">
                                <p class="data-load">&nbsp;</p>
                                <p class="data-load">&nbsp;</p>
                                <p class="data-load">&nbsp;</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card" style="border: 1px solid #ccc; cursor: pointer;">
                            <div class="card-body">
                                <p class="data-load">&nbsp;</p>
                                <p class="data-load">&nbsp;</p>
                                <p class="data-load">&nbsp;</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card" style="border: 1px solid #ccc; cursor: pointer;">
                            <div class="card-body">
                                <p class="data-load">&nbsp;</p>
                                <p class="data-load">&nbsp;</p>
                                <p class="data-load">&nbsp;</p>
                            </div>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="card" style="border: 1px solid #ccc; cursor: pointer;">
                            <div class="card-body">
                                <p class="data-load">&nbsp;</p>
                                <p class="data-load">&nbsp;</p>
                                <p class="data-load">&nbsp;</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" v-else>
                    <div class="col-6" v-for="i in filterData" :key="i.id">
                        <div class="card" style="border: 1px solid #ccc; cursor: pointer;" @click="selectCustomer(i.id)" data-dismiss="modal">
                            <div class="card-body">
                                <span class="text-primary" style="font-size: 10px;">{{ i.customer_no }} </span>
                                <span class="badge badge-success" v-if="i.rating_id === 'good'">{{ i.rating }}</span>
                                <span class="badge badge-danger" v-else>{{ i.rating }}</span>
                                <p class="text-primary font-12">{{ i.name }}</p>
                                <dl class="row">
                                    <dt class="col-md-4">Area</dt>
                                    <dd class="col-md-8">{{ i.area }}</dd>
                                    <!-- <dt class="col-md-4">Outstanding</dt>
                                    <dd class="col-md-8">{{ i.outstanding | currency }}</dd> -->
                                </dl>
                                <!-- <pre>{{ i }}</pre> -->
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'CustomerGridModal',
  data () {
    return {
      dateNow: new Date(),
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      dataRaw: [],
      data: {},
      searchQuery: '',
      ascending: false,
      sortClick: false,
      sortColumn: '',
      pageSize: 10,
      currentPage: 1,
      title: [{
        name: 'Rating',
        prop: 'rating_id'
      }, {
        name: 'Term Due',
        prop: 'term_due_id'
      }, {
        name: 'Customer No.',
        prop: 'customer_no'
      }, {
        name: 'Name',
        prop: 'name'
      }, {
        name: 'Group',
        prop: 'group'
      }, {
        name: 'Phone',
        prop: 'phone'
      }, {
        name: 'Address',
        prop: 'address'
      }],
      selectAll: false,
      selected: []
    }
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      customerList: state => state.customers.customerListLite
    }),
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.customerList.length
      } else {
        count = this.customerList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.customerList.length
      } else {
        count = this.customerList
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        // this.currentPage = 1
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.customerList.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    selectCustomer: function (id) {
      const customer = this.customerList.find(d => d.id === id)
      console.log(customer)
      this.$emit('selectCustomerList', customer)
    }
  }
}
</script>

<style>
.data-load {
  width: 100%;
  background-color: aliceblue;
}
</style>
